export class PunchInfo {
    public  userName='' //用户名
    public  companyId=''//公司id
    public punchDate=''    //打卡时间
    public punchPointId='' //打卡点位id
    public punchLongitude='' //打卡经度
    public punchLatitude='' //打卡纬度

}